module.exports = __webpack_public_path__ + "img/discover_mobile.d4fd204d.png";